let cardArr = [
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/b13411bb82c0467.png',
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/d079e08a8c9124c.png',
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/b72b4d84d7dc647.png',
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/df91def4edf202e.png',
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/8288f0c4deb3248.png',
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/9aa0fa1753f4b44.png',
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/5a7e61f70e1f060.png',
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/73bb384c3aba833.png',
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/f34aa293136a2c0.png',
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/54dab21e364d58e.png',
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/d2e8c8c1c00b56d.png',
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/e0e3f33d174527a.png',
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/457f157c31f64ab.png',
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/0da566897c80768.png',
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/0e4691f049a04ea.png',
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/69241284e8a2b10.png',
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/e2a838be59bbf0a.png',
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/ba17b2dd59aeee5.png',
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/47436dc464c09b5.png',
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/affa0778729d0c5.png',
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/4dbe75585065dd8.png',
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/5b797fcdd3e8b40.png',
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/438ffbd254dc9b7.png',
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/aeebd73aea18d6e.png',
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/0db4b7d1c01305d.png',
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/bbe87f63345f492.png',
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/bbe87f63345f492.png',
  'https://p1.ifengimg.com/7e8b28fdf67aad1a/2019/17/c6f6df5ebc6e013.png',
  'https://p0.ifengimg.com/7e8b28fdf67aad1a/2019/17/29.png'
]

export default cardArr;



// WEBPACK FOOTER //
// ./src/card.js